module.exports = __webpack_public_path__ + "assets/images/651ffe9d60f339703939902952b28f5b.png";